import { useEffect, useState } from 'react';

const slides = [
  {
    src: 'https://readdy.ai/api/search-image?query=Land%20Rover%20Range%20Rover%20Velar%20luxury%20SUV%20in%20dark%20charcoal%20color%20parked%20in%20a%20dramatic%20dark%20studio%20environment%2C%20cinematic%20lighting%2C%20sleek%20modern%20design%2C%20chrome%20details%2C%20low%20angle%20shot%2C%20ultra%20realistic%20automotive%20photography%2C%20moody%20dark%20background%20with%20elegant%20light%20reflections%20on%20the%20body%20panels&width=1920&height=1080&seq=landrover-velar-hero-03&orientation=landscape',
    alt: 'Land Rover Velar Miki Motors',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=black%20Porsche%20911%20sports%20car%20parked%20in%20a%20dark%20luxury%20garage%20with%20dramatic%20studio%20lighting%2C%20sleek%20black%20paint%2C%20chrome%20details%2C%20low%20angle%20shot%2C%20cinematic%20atmosphere%2C%20ultra%20realistic%20photography%2C%20high%20contrast%20dark%20background%20with%20subtle%20light%20reflections%20on%20the%20car%20body&width=1920&height=1080&seq=porsche-hero-01&orientation=landscape',
    alt: 'Porsche preto Miki Motors',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=black%20BMW%20M5%20luxury%20sports%20sedan%20parked%20in%20a%20dark%20upscale%20underground%20garage%2C%20dramatic%20cinematic%20lighting%2C%20glossy%20black%20paint%20with%20chrome%20accents%2C%20low%20angle%20perspective%2C%20ultra%20realistic%20automotive%20photography%2C%20moody%20dark%20atmosphere%20with%20subtle%20reflections%20on%20the%20polished%20body&width=1920&height=1080&seq=bmw-hero-02&orientation=landscape',
    alt: 'BMW Miki Motors',
  },
];

export default function Hero() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setCurrent((c) => (c + 1) % slides.length);
        setTransitioning(false);
      }, 700);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const goTo = (index: number) => {
    if (index === current || transitioning) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrent(index);
      setTransitioning(false);
    }, 700);
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden bg-[#0A0A0A]"
    >
      {/* Background carousel */}
      <div className="absolute inset-0 w-full h-full">
        {slides.map((slide, i) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            className="absolute inset-0 w-full h-full object-cover object-center"
            style={{
              opacity: i === current ? (transitioning ? 0 : 0.7) : 0,
              transition: 'opacity 700ms ease-in-out',
            }}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/30"></div>
      </div>

      {/* Decorative silver line */}
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-[#C0C0C0] to-transparent opacity-60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 border border-[#C0C0C0]/50 bg-[#C0C0C0]/10 rounded-full px-4 py-2 mb-8 transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            <span className="w-2 h-2 rounded-full bg-[#D4D4D4] animate-pulse"></span>
            <span className="text-[#D4D4D4] text-sm font-medium tracking-wider">
              Especialistas em Importados há mais de 11 anos
            </span>
          </div>

          {/* Title */}
          <h1
            className={`text-5xl md:text-7xl font-black leading-tight mb-6 transition-all duration-700 delay-100 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{
              fontFamily: "'Playfair Display', serif",
              background: 'linear-gradient(135deg, #ffffff 0%, #e8e8e8 20%, #C0C0C0 40%, #f5f5f5 55%, #a8a8a8 70%, #d4d4d4 85%, #ffffff 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Cuidamos do seu
            <br />
            <span
              style={{
                background: 'linear-gradient(135deg, #e0e0e0 0%, #ffffff 25%, #b0b0b0 45%, #f0f0f0 60%, #888888 75%, #c8c8c8 90%, #ffffff 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >Importado</span>
            <br />
            com Precisão
          </h1>

          {/* Subtitle */}
          <p
            className={`text-white/60 text-lg md:text-xl leading-relaxed mb-10 max-w-xl transition-all duration-700 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Mecânica especializada em BMW, Mercedes, Audi, Land Rover, Porsche e muito mais.
            Qualidade, rapidez e profissionalismo em Campinas – SP.
          </p>

          {/* Buttons */}
          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <a
              href="https://api.whatsapp.com/send/?phone=5519997889998&text=Olá, gostaria de fazer um orçamento&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-[#C0C0C0] text-black font-bold px-8 py-4 rounded-full hover:bg-white transition-all duration-300 text-base cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-line text-lg"></i>
              Faça seu Orçamento
            </a>
            <button
              onClick={() => {
                const el = document.querySelector('#servicos');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center justify-center gap-3 border border-white/30 text-white font-semibold px-8 py-4 rounded-full hover:border-[#C0C0C0] hover:text-[#C0C0C0] transition-all duration-300 text-base cursor-pointer whitespace-nowrap"
            >
              Ver Serviços
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Stats row */}
          <div
            className={`flex flex-wrap gap-8 mt-16 transition-all duration-700 delay-500 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            {[
              { value: '+10 Mil', label: 'Veículos Atendidos' },
              { value: '+5 Mil', label: 'Clientes Satisfeitos' },
              { value: '+27 Mil', label: 'Serviços Executados' },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span className="text-3xl font-black text-[#D4D4D4]" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {stat.value}
                </span>
                <span className="text-white/50 text-sm mt-1">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Carousel dots */}
      <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex items-center gap-3 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className="cursor-pointer transition-all duration-500 rounded-full"
            style={{
              width: i === current ? '32px' : '8px',
              height: '8px',
              background: i === current
                ? 'linear-gradient(90deg, #C0C0C0, #ffffff)'
                : 'rgba(255,255,255,0.3)',
            }}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/30 text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-[#C0C0C0] text-xl"></i>
      </div>
    </section>
  );
}
